/* eslint-disable jsx-a11y/control-has-associated-label */
import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import { IHistoryInputModel } from 'inputModels';
import { serialize } from 'object-to-formdata';
import { Controller, useForm } from 'react-hook-form';
import Modal from 'react-modal';
import { IHistoryViewModel } from 'viewModels';
import * as yup from 'yup';
import { ReactComponent as IconObs } from '../../../assets/icons/icon-obs.svg';
import { useSolicitation } from '../../../context/solicitation';
import { SolicitationController } from '../../../controller/SolicitationController';
import { HistoryType } from '../../../types/enums';
import { Button } from '../../Buttons/Button';
import { ContentButtons, ContentModal, Header } from './styles';

interface Props {
  isOpen: boolean;
  onRequestClose: () => void;
  solicitationId: string;
  zIndex?: number;
}
export function ModalAddObservation({ isOpen, onRequestClose, solicitationId, zIndex }: Props) {
  const { solicitations, setSolicitations } = useSolicitation();
  const defaultValues = {
    text: '',
    attachments: [],
    createdAt: new Date(),
    type: HistoryType.NOTE,
    createdBy: new Date(),
    demandId: '',
    solicitationId: '',
  };

  const registerSchema = yup.object({
    text: yup.string().required('Campo obrigatório'),
    attachments: yup.array(),
    createdAt: yup.date(),
    type: yup.string(),
    createdBy: yup.date(),
    demandId: yup.string(),
    solicitationId: yup.string(),
  });

  const {
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(registerSchema),
    reValidateMode: 'onChange',
    defaultValues,
  });

  const handleSendObservation = (data: IHistoryInputModel) => {
    const history: IHistoryInputModel = {
      text: data.text,
      type: HistoryType.NOTE,
      solicitationId,
    };

    const formData = serialize(history, { indices: true });

    SolicitationController.addHistory(formData).then((id) => {
      onRequestClose();
      reset();
      const solicitationIdx = solicitations?.findIndex((s) => s.id === solicitationId);
      if (solicitationIdx !== -1) {
        const newHistory: IHistoryViewModel = {
          id,
          text: history.text || '',
          type: history.type,
          solicitationId,
          createdAt: new Date(),
          visible: true,
        };
        setSolicitations((prev) => {
          const newSolicitations = [...prev];
          newSolicitations[solicitationIdx].history?.push(newHistory);
          newSolicitations[solicitationIdx].history?.sort(
            (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
          );
          return newSolicitations;
        });
      }
    });
  };

  const handleDiscard = () => {
    reset();
    onRequestClose();
  };
  const setZIndex =
    zIndex !== undefined
      ? {
          overlay: {
            zIndex: zIndex || 1,
          },
        }
      : {};
  return (
    <Modal
      style={setZIndex}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-add-modal-content">
      <Header>
        <div className="subHeader">
          <IconObs />
          <h1>Anotações</h1>
        </div>
        <div className="close-div">
          <button type="button" onClick={onRequestClose}>
            <CloseIcon fontSize="small" />
          </button>
        </div>
      </Header>
      <ContentModal>
        <Controller
          control={control}
          name="text"
          render={({ field: { value, onChange, ...rest } }) => (
            <>
              <textarea value={value} onChange={onChange} {...rest} className="text" />
              {errors.text && (
                <span className="fieldError">
                  <ErrorIcon fontSize="inherit" />
                  {errors.text.message}
                </span>
              )}
            </>
          )}
        />
      </ContentModal>
      <ContentButtons>
        <Button
          text="Descartar"
          style={{ fontSize: '1.20rem', display: 'flex', alignItems: 'center' }}
          dimensions={{
            width: '10rem',
            height: '2rem',
          }}
          positionLeftElement={5}
          border={{ color: 'secondary', width: 0 }}
          color="background_white"
          background="primary"
          onClick={handleDiscard}
        />
        <Button
          text="Enviar Anotação"
          style={{ fontSize: '1.20rem', display: 'flex', alignItems: 'center' }}
          dimensions={{
            width: '12rem',
            height: '2rem',
          }}
          positionLeftElement={5}
          border={{ color: 'secondary', width: 0 }}
          color="background_white"
          background="secondary"
          onClick={handleSubmit(handleSendObservation)}
        />
      </ContentButtons>
    </Modal>
  );
}
